export const colors = {
  'action-primary': '#637575',
  'action-primary-hovered': '#475757',
  'action-primary-pressed': '#354243',
  'action-primary-subdued': '#354243',
  'action-primary-subdued-hovered': '#475757',
  'action-primary-subdued-pressed': '#475757',
  'action-primary-disabled': '#42403b',
  'action-neutral': '#2a2825',
  'action-neutral-hovered': '#42403b',
  'action-neutral-pressed': '#55534e',
  'action-neutral-subdued': '#2a2825',
  'action-neutral-subdued-hovered': '#42403b',
  'action-neutral-subdued-pressed': '#55534e',
  'action-neutral-disabled': '#42403b',
  'action-destructive': '#bc5044',
  'action-destructive-hovered': '#90372e',
  'action-destructive-pressed': '#712821',
  'action-destructive-subdued': '#4a1712',
  'action-destructive-subdued-hovered': '#712821',
  'action-destructive-subdued-pressed': '#90372e',
  'action-destructive-disabled': '#42403b',
  background: '#181715',
  'background-hovered': '#2a282580',
  'background-pressed': '#2a2825',
  'background-selected': '#2a2825',
  'background-backdrop': '#00000080',
  'background-overlay': '#00000080',
  'background-divider': '#a5a198',
  content: '#fcf7ea',
  'content-subdued': '#d8d4c8',
  'content-muted': '#a5a198',
  'content-hovered': '#f8f3e6',
  'content-pressed': '#d8d4c8',
  'content-disabled': '#75726b',
  'content-on-positive': '#cceed6',
  'content-on-attention': '#ffe1c3',
  'content-on-highlight': '#d8e7ff',
  'content-on-negative': '#ffdfda',
  'content-on-negative-hovered': '#ffc6bd',
  'content-on-negative-pressed': '#ffc6bd',
  'content-primary': '#f1f3f3',
  'content-on-primary': '#FFFFFF',
  'content-on-inverse': '#181715',
  'content-on-destructive': '#fcf7ea',
  'content-on-interactive': '#fcf7ea',
  'content-on-background': '#fcf7ea',
  'content-on-background-subdued': '#d8d4c8',
  'content-on-background-hovered': '#f8f3e6',
  'content-on-background-pressed': '#d8d4c8',
  'content-on-background-disabled': '#75726b',
  interactive: '#637575',
  'interactive-hovered': '#475757',
  'interactive-pressed': '#354243',
  'interactive-disabled': '#181715',
  'interactive-destructive': '#bc5044',
  'interactive-destructive-hovered': '#90372e',
  'interactive-destructive-pressed': '#712821',
  'interactive-destructive-disabled': '#181715',
  topbar: '#2a2825',
  'topbar-subdued': '#42403b',
  'content-on-topbar': '#fcf7ea',
  'line-on-topbar': '#55534e80',
  'line-on-topbar-pressed': '#75726b',
  link: '#e4d0bf',
  'link-hovered': '#c29a77',
  'link-pressed': '#97683b',
  line: '#55534e80',
  'line-subdued': '#42403b',
  'line-hovered': '#55534e',
  'line-pressed': '#75726b',
  'line-selected': '#55534e',
  'line-disabled': '#42403b',
  'line-transparent': '#ffffff1a',
  'line-positive': '#051b0e',
  'line-positive-subdued': '#051b0e',
  'line-highlight': '#08162f',
  'line-highlight-subdued': '#08162f',
  'line-negative': '#2f0b08',
  'line-negative-subdued': '#2f0b08',
  'line-negative-disabled': '#712821',
  'line-attention': '#241304',
  'line-attention-subdued': '#241304',
  focused: '#637575',
  skeleton: '#42403b',
  surface: '#2a2825',
  'surface-subdued': '#42403b',
  'surface-hovered': '#42403b',
  'surface-subdued-hovered': '#55534e',
  'surface-pressed': '#55534e',
  'surface-disabled': '#42403b',
  'surface-selected': '#354243',
  'surface-selected-hovered': '#475757',
  'surface-selected-pressed': '#475757',
  'surface-attention': '#5b38144d',
  'surface-attention-subdued': '#3c220a4d',
  'surface-negative': '#7128214d',
  'surface-negative-subdued': '#4a17124d',
  'surface-negative-subdued-hovered': '#2f0b084d',
  'surface-negative-subdued-pressed': '#2f0b084d',
  'surface-positive': '#17492d4d',
  'surface-positive-subdued': '#0b2e1a4d',
  'surface-highlight': '#213f734d',
  'surface-highlight-subdued': '#12274c4d',
  'surface-highlight-subdued-hovered': '#08162f4d',
  'surface-highlight-subdued-pressed': '#08162f4d',
  'surface-neutral': '#55534e',
  'surface-neutral-subdued': '#42403b',
  'surface-inverse': '#fcf7ea',
  'decorative-surface-1': '#FFC96B',
  'decorative-surface-1-subdued': '#FFE4B5',
  'decorative-content-1': '#7E5700',
  'decorative-surface-2': '#FFC4B0',
  'decorative-surface-2-subdued': '#FFE1D7',
  'decorative-content-2': '#AF294E',
  'decorative-surface-3': '#92E6B5',
  'decorative-surface-3-subdued': '#C9F3DA',
  'decorative-content-3': '#006D41',
  'decorative-surface-4': '#91E0D6',
  'decorative-surface-4-subdued': '#C8EFEB',
  'decorative-content-4': '#006A68',
  'decorative-surface-5': '#FDC9D0',
  'decorative-surface-5-subdued': '#FEE4E7',
  'decorative-content-5': '#AE2B4C',
  'decorative-surface-6': '#7CD4FD',
  'decorative-surface-6-subdued': '#BDE9FE',
  'decorative-content-6': '#065986',
  'decorative-surface-7': '#BDB4FE',
  'decorative-surface-7-subdued': '#DED9FF',
  'decorative-content-7': '#4A1FB8',
}
